export default "__VITE_ASSET__DwMFcY7q__"